export default "__VITE_ASSET__a92ca59f__"